import React from 'react';
import { FilterBadgeHookParams, AdSetBadgeHookResult } from '../types';

interface AdSet {
  id: string;
  name: string;
}

interface UseAdSetBadges extends FilterBadgeHookParams {
  adSets?: AdSet[];
  adSetIds?: string[];
}

export const useAdSetBadges = ({ adSets = [], adSetIds = [] }: UseAdSetBadges): AdSetBadgeHookResult => {
  const adSetBadges = React.useMemo(() => {
    const selectedAdSets: AdSet[] = [];

    // Safety check: ensure adSets is an array
    if (!Array.isArray(adSets)) {
      console.warn('🔍 [AdSetBadges] adSets is not an array:', adSets);
      return selectedAdSets;
    }

    adSets.forEach((adSet) => {
      // Check if ad set is selected
      if (adSetIds.includes(adSet.id)) {
        selectedAdSets.push(adSet);
      }
    });

    return selectedAdSets;
  }, [adSets, adSetIds]);

  return {
    adSetBadgesProps: {
      data: adSetBadges,
    },
  };
};
